export const apiCallDebounceTime = 500;
// Base URL's
export const dataApiUrl = process.env.REACT_APP_DATA_API_URL;
export const authUrl = process.env.REACT_APP_AUTH_API_URL;
export const productEsUrl = `${process.env.REACT_APP_ES_ENDPOINT}/product`;
export const assetEsUrl = `${process.env.REACT_APP_ES_ENDPOINT}/${process.env.REACT_APP_ASSET_ES_INDEX}`;
export const esApiKey = process.env.REACT_APP_ELASTIC_SEARCH_API_KEY;
export const jiraDomainUrl = process.env.REACT_APP_JIRA_LINK;
export const dataLoaderUrl = process.env.REACT_APP_DATA_LOADER_URL;
export const assetsReportingDashboardUrl = process.env.REACT_APP_ASSET_REPORTING_DASHBOARD;
// Corgis data-api URLS
export const assetsUrlPath = dataApiUrl + '/assets';
export const productsUrlPath = dataApiUrl + '/products';
// Get Tags URL
export const getTagsDataUrl = dataApiUrl + '/tags';
// Corgis lifeCycle service API Urls
// Create assets post URL
export const bulkSearchUrl = assetsUrlPath + '/import/matches';
